module.exports = __webpack_public_path__ + "img/logo.7554e007.svg";